<script lang="ts">
    export let url:string;
    export let path:string;
</script>

<div class="Path">Path: {path}</div>
<img src="{url}" alt="" class="Image"/>

<style type="text/scss">
    .Image {
      max-width: 100%;
      display: inline-block;
    }
</style>
